export const NOTIFICATION_PRIVATE = Symbol('notification-private');
//# sourceMappingURL=privates.js.map